import { LearnModule } from 'api';
import { useMemo } from 'react';

type UseLearnModuleProps = {
  learnModuleItems: LearnModule[];
  moduleLimit: number;
};

const useLearnModule = ({
  learnModuleItems,
  moduleLimit
}: UseLearnModuleProps) => {
  const {
    defaultLearnModules,
    excessLearnModules,
    hasExcessModules,
    MODULE_TOTAL
  } = useMemo(() => {
    const defaultModules = learnModuleItems.slice(0, moduleLimit);
    const excessModules =
      learnModuleItems.length > moduleLimit
        ? learnModuleItems.slice(moduleLimit)
        : [];

    return {
      defaultLearnModules: defaultModules,
      excessLearnModules: excessModules,
      hasExcessModules: excessModules.length > 0,
      MODULE_TOTAL: learnModuleItems.length
    };
  }, [learnModuleItems, moduleLimit]);

  return {
    defaultLearnModules,
    excessLearnModules,
    hasExcessModules,
    MODULE_TOTAL
  };
};

export default useLearnModule;
